import Phaser from 'phaser';
import { LOCATIONS_VISIT_ORDER } from '../constants/AppConstants';

export default class SuitcasePanels extends Phaser.Group {
  constructor(game, locationid) {
    super(game);

    this.bg = null;
    this.updateBackground(locationid);
  }

  updateBackground(locationid) {
    let locale = LOCATIONS_VISIT_ORDER[locationid];

    this.bg =
      typeof locale != 'undefined'
        ? this.game.make.sprite(0, 0, locale.toLowerCase() + '_suitcase_background')
        : this.game.make.sprite(0, 0, 'background_generic');
    this.add(this.bg);

    this.addMask(locale);
  }

  addMask(locationid) {
    this.overlayMask = this.game.make.graphics();
    this.overlayMask.beginFill(0x0090c1);
    this.overlayMask.drawRect(0, 0, this.bg.width, this.bg.height);
    this.add(this.overlayMask);
    this.tweenMask(this.game.gameController.player.getLocationVisited(locationid));
  }

  tweenMask(visited) {
    let hasVisited = visited ? 0.45 : 0.85;
    this.game.add
      .tween(this.overlayMask)
      .to({ alpha: hasVisited }, 500)
      .start();
  }
}



// WEBPACK FOOTER //
// ./js/app/suitcase/SuitcasePanels.js